import React from 'react'
import { Form, Message } from 'semantic-ui-react'
import { Components } from '@kyndio/kynd-shared-components'
import * as clientTheme from 'theme'

import {
  FooterContainer,
  RightAlignWrapper,
  TermsCheckbox,
  SubmitContainer,
  SubmitButton,
  DomainContainer,
  ErrorMessage,
  EmailInput
} from './styles'

const FormStep1 = (props) => {
  // eslint-disable-next-line react/prop-types
  const { intl, loading, disabled, prefilled, username, domain, email, code, name, orgName, terms, formError, errors, onMainAction, onChange, onBlur, onHandleTermsModalChange } = props

  return (
    <Components.FormContainer
      onSubmit={onMainAction}
    >
      <Components.StyledForm
        error={formError}
        loading={loading}
        autoComplete="off"
      >
        <div className="submit-section-balancer" />
        <div className="fields-section">
          <div>
            <Components.LogoContainer>
              <Components.BrandedLogo theme={clientTheme} />
            </Components.LogoContainer>
          </div>
          <Components.FieldWrapper>
            <Form.Field>
              <label>{intl.formatMessage({ id: 'phishing_tool_company_email' })}</label>
              {prefilled
                ? <EmailInput inline>
                  <Form.Input
                    name="username"
                    placeholder="me"
                    onChange={onChange}
                    onBlur={onBlur}
                    value={username}
                    error={errors.username}
                  />
                  <DomainContainer>
                    @{domain}
                  </DomainContainer>
                  </EmailInput>
                : <Form.Input
                  name="email"
                  placeholder="me@mycompany.com"
                  onChange={onChange}
                  onBlur={onBlur}
                  value={email}
                  error={errors.email}
                />
              }
            </Form.Field>
          </Components.FieldWrapper>
          <Components.FieldWrapper>
            <Form.Field>
              <label>{intl.formatMessage({ id: 'phishing_tool_unique_code' })}</label>
              <Form.Input
                name="code"
                placeholder="A1b2C3d4"
                onChange={onChange}
                onBlur={onBlur}
                value={code}
                error={errors.code || errors.wrongCode}
                disabled={prefilled}
              />
            </Form.Field>
            {
              errors.wrongCode &&
              <ErrorMessage>
                {intl.formatMessage({ id: 'phishing_tool_unique_code_error' }, { orgDomain: domain })}
              </ErrorMessage>
            }
          </Components.FieldWrapper>
          <Components.FieldWrapper>
            <Form.Field>
              <label>{intl.formatMessage({ id: 'phishing_tool_name' })}</label>
              <Form.Input
                name="name"
                placeholder="Joe Bloggs"
                onChange={onChange}
                value={name}
                error={errors.name}
              />
            </Form.Field>
          </Components.FieldWrapper>
          <Components.FieldWrapper>
            <Form.Field>
              <label>{intl.formatMessage({ id: 'phishing_tool_company_name' })}</label>
              <Form.Input
                name="orgName"
                placeholder="Example Co"
                onChange={onChange}
                value={orgName}
                error={errors.orgName}
              />
            </Form.Field>
          </Components.FieldWrapper>

          <Components.FieldWrapper>
            <Message
              error
              content={intl.formatMessage({
                id: 'phishing_tool_form_error'
              })}
            />
          </Components.FieldWrapper>
        </div>

        <div className="submit-section">
          <div className="submit-container-inner">
            <FooterContainer>
              <RightAlignWrapper>
                {intl.formatMessage({ id: 'phishing_tool_terms_label' })}
                <Components.TermsAndConditionsModal
                  title={intl.formatMessage({ id: 'phishing_tool_terms_label_link' })}
                  content={intl.formatMessage({ id: 'terms_kynd' })}
                  link={intl.formatMessage({ id: 'phishing_tool_terms_label_link' })}
                  setTermsAndConditions={onHandleTermsModalChange}
                  {...props}
                />
                <TermsCheckbox
                  name="terms"
                  checked={terms}
                  onChange={onChange}
                  error={errors.terms}
                />

              </RightAlignWrapper>

              <SubmitContainer>
                <SubmitButton
                  type="submit"
                  disabled={disabled}
                >
                  {intl.formatMessage({ id: 'phishing_tool_continue' })}
                </SubmitButton>
              </SubmitContainer>
            </FooterContainer>
          </div>
        </div>
      </Components.StyledForm>
    </Components.FormContainer>
  )
}

export default FormStep1
